import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/agentConversation/view/agentConversation.view.query.gql"
import type {
  AgentConversationViewQuery,
  AgentConversationViewQueryVariables,
} from "@/v2-backoffice-client/agentConversation/view/__types__/agentConversation.view.query"

type Options = QueryHookOptions<
  AgentConversationViewQuery,
  AgentConversationViewQueryVariables
>

export function useAgentConversationViewQuery(options?: Options) {
  return useQuery<
    AgentConversationViewQuery,
    AgentConversationViewQueryVariables
  >(query, options)
}
